<template>
  <div class="page">
    <div class="top">
      <div class="top-title">
        <div class="title-name">20G-500G</div>
        <div class="title-yx">月享</div>
      </div>
      <div class="tyll">高速全国通用流量</div>
      <div class="tydz">低至<span>2</span>元/月</div>
    </div>
    <div class="el-content">
      <div class="v-table">
        <div class="leftcontent"><span>多合一</span>套餐介绍</div>
        <div class="v-c-table">
          <div class="title-ts">首次激活套餐支付100元得240元，240元活动余额直接到账，订购套餐，即可畅享网络。</div>
          <div class="table">
            <div class="table-tr">
              <div>月享流量</div>
              <div>原套餐月租</div>
              <div>优惠后低至</div>
            </div>
            <!-- <div class="table-td">
              <div>30G</div>
              <div>¥15.9</div>
              <div>¥2.9</div>
            </div>
            <div class="table-td">
              <div>100G</div>
              <div>¥15.9</div>
              <div>¥2.9</div>
            </div> -->
            <div class="table-td">
              <div>300G</div>
              <div>¥39</div>
              <div>¥19</div>
            </div>
            <div class="table-td">
              <div>500G</div>
              <div>¥49</div>
              <div>¥29</div>
            </div>
          </div>
          <div class="shangx">上述套餐全部都为长期套餐</div>
        </div>
      </div>
      <div class="sumbit" @click="sureToRecharge()">立即开通</div>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant'
import { wxRequest } from '@/api/user.js'
export default {
  data() {
    return {
      newHome: this.$store.state.newHome,
      newHomes: localStorage.getItem('newHome'),
      input: this.$store.state.recordLoginText,
      isDialogShow: false,
      // 设置密码
      password: '',
      confirmPassword: '',
      alreadySetUp: false,
      showPasswordPanel: false,
      passwordKeyboard: false,
      confirmPasswordKeyboard: false,
      passwordPanelTop: 50,

      // 当前余额套餐
      currentItem: 0,
      price: 0,
      giftBalance: 0,

      // 自定义金额
      popup: false,

      // 自定义键盘
      showKeyboard: false,
      definedPrice: '',

      type: '',
      indexActive: ''
    }
  },
  methods: {
    /** *   修改密码     ***/
    passwordOnfocus() {
      this.passwordKeyboard = true
      this.confirmPasswordKeyboard = false
      this.passwordPanelTop = 30
    },
    passwordOnDelete() {
      this.password = this.password.slice(0, this.password.length - 1)
    },

    passwordOnInput(key) {
      this.password = (this.password + key).slice(0, 6)
    },

    confirmPasswordOnfocus() {
      this.passwordKeyboard = false
      this.confirmPasswordKeyboard = true
      this.passwordPanelTop = 30
    },
    confirmPasswordOnDelete() {
      this.confirmPassword = this.confirmPassword.slice(0, this.confirmPassword.length - 1)
    },

    confirmPasswordOnInput(key) {
      this.confirmPassword = (this.confirmPassword + key).slice(0, 6)
    },

    cancelChangePassword() {
      this.password = ''
      this.confirmPassword = ''
      this.passwordPanelTop = 50
      this.showPasswordPanel = false
    },

    checkPassword() {
      if (this.password.length < 6) {
        Dialog.alert({ message: '请设置六位支付密码' })
        return false
      }

      if (this.password != this.confirmPassword) {
        Dialog.alert({ message: '两次输入的新密码不一致' })
        return false
      }
      return true
    },

    /** *   修改密码  end   ***/
    sumbit() {
      this.showPasswordPanel = true
    },
    onBridgeReady(param) {
      const _this = this
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest', param,
        function(res) {
          if (res.err_msg == 'get_brand_wcpay_request:ok') {
            _this.$router.push({
                path: '/user/home',
                query: {
                  iccid: _this.$store.state.iccid
                }
              }).catch(() => {

              })
          }
        }
      )
    },
    sureToRecharge() {
      var params = {
        iccid: this.$store.state.iccid ? this.$store.state.iccid : localStorage.getItem('iccid'),
        amount: 100 * 100, // 固定值
        giftBalance: 0, // 固定值
        yucun: 1, // 固定值
        payType: 20 // 固定微信支付

      }
      wxRequest('order/user/create/priceOrder', params, 'post').then(res => {
        if (res.data.code == 200) {
          if (params.payType == 50) { // 乐刷
            window.location.href = res.data.data.jspay_url
          } else if (params.payType == 20) { // 微信第三方
            var param = res.data.data.param
            if (typeof WeixinJSBridge === 'undefined') {
              if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false)
              } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady)
                document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady)
              }
            } else {
              this.onBridgeReady(param)
            }
          } else if (params == 60) { // 汇付天下
            const datas = JSON.parse(res.data.data)
            if (datas.status === 'succeeded') {
              const payment = datas
              AdaPay.doPay(payment, (res) => {
                Dialog.alert({ title: '提示', message: res.result_message })
              })
            }
          }
        } else {
          Dialog.alert({ message: res.data.message })
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.page{
    height:100vh;
    background: #f43805 url('../../assets/img/rbg.png') no-repeat;
    background-size:100%;
    padding-top:12px;
    position: relative;
    .top{
        width:80%;
        margin: 0 auto;
        background: url('../../assets/img/tbg.png') no-repeat;
        background-size:100%;
        height:182px;
        .top-title{
            display: flex;
            align-items: center;
            padding:10px 27px;
            .title-name{
                font-size:40px;
                font-weight:600;
                color: #F74D12;
            }
            .title-yx{
                background: #E2A542;
                font-size:14px;
                border-radius:4px;
                padding:5px;
                color: #fff;
                margin-left:4px;
            }
        }
        .tyll{
            color: #F74D12;
            padding-left:25px;
            font-size:14px;
        }
        .tydz{
            font-size: 17px;
            font-family: HarmonyOS_Sans_SC_Medium;
            color: #2E2C23;
            padding-left:25px;
            font-weight:600;
            margin-top:10px;
            span{
                font-size:30px;
            }
        }
    }
    .el-content{
        background: url('../../assets/img/rbg1.png') no-repeat;
        background-size:100%;
        position: absolute;
        top:80px;
        padding-top:130px;
        .v-table{
            width:94%;
            margin: auto;
            background: rgba(255, 248, 235, .4);
            border-radius: 6px;
            padding:10px 0 ;
            position: relative;
            .leftcontent{
                background: url('../../assets/img/lbg.png')no-repeat ;
                background-size: 100%;
                height: 37px;
                font-size: 12px;
                width: 144px;
                text-align: center;
                line-height:36px;
                color: #fff;
                position: absolute;
                left: 0;
                top:0;
                span{
                    font-size: 16px;
                    font-family: REEJI-JinGang-ExtraBold, REEJI-JinGang;
                    font-weight: 800;
                    color: #FFE100;
                }
            }
            .v-c-table{
                margin:10px;
                background: #FFFBF8;
                padding:0 5px;
                border-radius: 6px;
                .title-ts{
                    color: #F86C2E;
                    padding-top:42px;
                    font-size:15px;
                    line-height: 22px;
                    padding-bottom:16px;
                }
                .table{
                    border:1px solid #EEDBB5;
                    .table-tr{
                        display: flex;
                        align-items: center;
                        font-size:14px;
                        height:32px;
                        line-height:32px;
                        text-align: center;
                        background: #FFF6DC;
                        div{
                            width:33.32%;
                            color: #C4A768;
                            &:nth-child(2){
                                border-left:1px solid #EEDBB5;
                                border-right:1px solid #EEDBB5;
                            }
                        }
                    }
                    .table-td{
                        display: flex;
                        align-items: center;
                        font-size:14px;
                        height:32px;
                        line-height:32px;
                        text-align: center;

                        font-weight: 600;
                        border-top:1px solid #EEDBB5;
                        div{
                            width:33.32%;
                            color: #2E2C23;
                            &:nth-child(2){
                                border-left:1px solid #EEDBB5;
                                border-right:1px solid #EEDBB5;
                            }
                            &:nth-child(3){
                                color: #FF0000;
                            }
                        }
                    }
                }
            }
        }
        .shangx{
            color: #726E5B;
            text-align: center;
            font-size:15px;
            padding:26px 0;
            position: relative;
            &::after{
                content:'';
                width:7px;
                height: 7px;
                display: block;
                position: absolute;
                left:46px;
                top:30px;
                transform:rotate(45deg);
                background: #FF924D;
            }
        }
        .sumbit{
            width:94%;
            height:56px;
            background: url('../../assets/img/bbg.png') no-repeat;
            background-size:100%;
            text-align: center;
            line-height:56px;
            color:#fff;
            margin:18px auto;
            font-size:16px;
        }
    }
}
</style>

